import { render, staticRenderFns } from "./ChangeCompany.vue?vue&type=template&id=d3b4ec52&"
import script from "./ChangeCompany.vue?vue&type=script&lang=js&"
export * from "./ChangeCompany.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports